import { Box } from '@mui/material';
import styled from 'styled-components';

export const LoaderBase = styled(Box)`
    svg {
        height: ${(props) => (props?.height ? `${props?.height}` : '100%')};
        width: ${(props) => (props?.width ? `${props?.width}` : '100%')};
    }
`;
